import {createRouter, createWebHistory} from 'vue-router'
import HomeView from '@/views/HomeView.vue'
import PrivacyPolicy from '@/views/PrivacyPolicy.vue'
import QuizStep from '@/views/QuizStep.vue'
import { mktViewPage } from '@/helpers/marketingEvents.ts'
import { useQuizStore } from '@/stores/quizStore.ts'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: 'home',
      component: HomeView,
    },
    {
      path: '/privacy-policy',
      name: 'privacy-policy',
      component: PrivacyPolicy,
    },
    {
      path: '/quiz/:step?',
      name: 'quiz',
      component: QuizStep,
    },
  ],
})

router.beforeEach((to) => {
  const { getStoredData, leadSource } = useQuizStore()
  const data = getStoredData()
  mktViewPage(
    leadSource.value,
    data.email,
    data.contact
  )
})

export default router
